import { AnalyticsAutoProps, AnalyticsEventKey, AnalyticsEvents } from "./types";

export abstract class AbstractAnalyticsClient {
  /**
   * A method to track an analytics even to the vendor analytics service.
   * This method should be implemented by the concrete analytics client.
   *
   * @abstract
   * @param event - the event name to track
   * @param properties - the properties to track with the event
   * @param autoProps - the properties automatically added to each event
   */
  protected abstract sendEvent<T extends AnalyticsEventKey>(event: T, properties?: Partial<AnalyticsEvents[T]>, autoProps?: AnalyticsAutoProps): void;

  protected abstract getAutoProps(): AnalyticsAutoProps | undefined;
}
